(function () {
  const SECTION_SEL = '[data-section-type="promotion-grid"]';
  const GRID_SEL = '.flex-grid';
  const ITEM_SEL = '.flex-grid__item';

  function buildRail() {
    if (document.querySelector('.promo-rail')) return; // already built

    const sections = Array.from(document.querySelectorAll(SECTION_SEL));
    if (!sections.length) { console.warn('PromoRail: no promotion-grid sections found'); return; }

    const grids = sections.map(s => s.querySelector(GRID_SEL)).filter(Boolean);
    const items = grids.flatMap(g => Array.from(g.querySelectorAll(ITEM_SEL)));
    if (!items.length) { console.warn('PromoRail: no items in grids'); return; }

    const rail = document.createElement('div');
    rail.className = 'promo-rail';
    rail.setAttribute('aria-label', 'Featured promotions');

    items.forEach(el => {
      const card = document.createElement('div');
      card.className = 'promo-card';
      card.appendChild(el.cloneNode(true));
      rail.appendChild(card);
    });

    // Insert the rail right before the first Promotion grid section
    sections[0].parentNode.insertBefore(rail, sections[0]);

    document.body.classList.add('promo-rail-ready');
    console.log('PromoRail: built', items.length, 'items from', grids.length, 'grids');
  }

  // Run on storefront and in the Theme Editor
  document.addEventListener('DOMContentLoaded', buildRail);
  window.addEventListener('load', buildRail);
  document.addEventListener('shopify:section:load', buildRail);
})();
